<template>
  <v-layout justify-center>
    <v-flex>
      <v-card>
        <v-form v-model="valid" lazy-validation ref="form">
          <v-card-text>
            <v-layout wrap v-if="sideMenu">
              <v-flex xs12 sm4>
                <v-subheader>Image</v-subheader>
              </v-flex>
              <v-flex xs12 sm8 v-if="sideMenu.image">
                <v-img contain max-height="200" :src="sideMenu.image" />
                <Storage v-model="sideMenu.image" type="sideMenus" />
              </v-flex>

              <v-flex xs12 sm4>
                <v-subheader>Name</v-subheader>
              </v-flex>
              <v-flex xs12 sm8>
                <v-text-field
                  label="Name"
                  v-model="sideMenu.pageName"
                  :rules="[formRules.required]"
                />
              </v-flex>

              <v-flex xs12>
                <v-layout wrap row align-center>
                  <v-flex xs4>
                    <v-navigation-drawer width="350">
                      <v-list>
                        <v-list-tile
                          v-for="(actionItem, i) in sideMenu.actionItems"
                          :key="i"
                          @click.stop="updateActionItem(actionItem)"
                        >
                          <v-list-tile-avatar>
                            <v-icon v-text="fa(actionItem.icon)"></v-icon>
                          </v-list-tile-avatar>

                          <v-list-tile-content>
                            <v-list-tile-title>{{
                              actionItem.text
                            }}</v-list-tile-title>
                          </v-list-tile-content>

                          <v-list-tile-action :class="$style.listAction">
                            <v-btn
                              icon
                              @click.stop="
                                sideMenu.actionItems.splice(
                                  i - 1,
                                  0,
                                  actionItem
                                );
                                sideMenu.actionItems.splice(i + 1, 1);
                              "
                              :disabled="loading"
                              v-if="i > 0"
                            >
                              <v-icon v-text="fa('angle-up')"></v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              @click.stop="
                                sideMenu.actionItems.splice(i, 1);
                                sideMenu.actionItems.splice(
                                  i + 1,
                                  0,
                                  actionItem
                                );
                              "
                              :disabled="loading"
                              v-if="i < sideMenu.actionItems.length - 1"
                            >
                              <v-icon v-text="fa('angle-down')"></v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              @click.stop="sideMenu.actionItems.splice(i, 1)"
                              :disabled="loading"
                            >
                              <v-icon v-text="fa('trash-alt')"></v-icon>
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-list>
                    </v-navigation-drawer>
                  </v-flex>
                  <v-flex xs8>
                    <v-btn
                      color="primary"
                      @click="addActionItem"
                      :loading="loading"
                    >
                      <v-icon v-text="fa('plus')" dark></v-icon>
                      Add action item
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              :disabled="!valid"
              color="primary"
              :loading="loading"
              @click="save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-form v-model="actionItemFormValid" lazy-validation ref="actionForm">
          <v-card-title>
            <span class="headline">New Action item</span>
          </v-card-title>

          <v-card-text v-if="newActionItem">
            <v-text-field
              v-model="newActionItem.text"
              :rules="[formRules.required]"
              label="Text"
              required
            />
            <icon-picker v-model="newActionItem.icon" />
            <ActionType v-model="newActionItem.action.type" />
            <ActionLink
              v-model="newActionItem.action.link"
              :type="newActionItem.action.type"
              @clearLink="$delete(newActionItem.action, 'link')"
            />
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn @click="close" :disabled="loading">Cancel</v-btn>
            <v-btn
              color="primary"
              @click="saveActionItem"
              :disabled="!actionItemFormValid"
              :loading="loading"
              v-if="sideMenu"
            >
              {{ newActionItem && newActionItem.index >= 0 ? "Update" : "Add" }}
              Action item</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { db } from "../../plugins/firebase";
import { appMapSuffix, eventHub } from "../../config/constants";
import ActionType from "../../components/ActionType";
import ActionLink from "../../components/ActionLink";
import Storage from "../../components/Storage";
const sideMenusCollection = db.collection("sideMenus");

export default {
  name: "SideMenus",
  components: { ActionLink, ActionType, Storage },
  data() {
    return {
      valid: false,
      loading: false,
      actionItemFormValid: false,
      dialog: false,
      newActionItem: null,
      actionItem: {
        icon: null,
        text: null,
        showCondition: null,
        action: {
          type: "NONE"
        }
      },
      sideMenu: null
    };
  },
  methods: {
    updateActionItem(actionItem) {
      const { icon, text, showCondition, action } = actionItem;
      this.newActionItem = {
        index: this.sideMenu.actionItems.indexOf(actionItem),
        icon,
        text,
        showCondition,
        action: {
          type: action.type,
          ...(action.link ? { link: action.link } : {})
        }
      };
      this.dialog = true;
    },
    addActionItem() {
      this.newActionItem = {
        ...this.actionItem,
        action: {
          type: "NONE"
        }
      };
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.newActionItem = null;
    },
    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      try {
        await db.runTransaction(async t =>
          t.set(this.$firestoreRefs.sideMenu, this.sideMenu)
        );
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
      this.close();
    },
    saveActionItem() {
      if (!this.$refs.actionForm.validate()) {
        return;
      }
      const actionItemIndex = this.newActionItem.index;
      if (actionItemIndex >= 0) {
        delete this.newActionItem.index;
        this.sideMenu.actionItems.splice(
          actionItemIndex,
          1,
          this.newActionItem
        );
      } else {
        this.sideMenu.actionItems.push(this.newActionItem);
      }
      this.save();
      this.close();
    }
  },
  watch: {
    "$route.params.language": {
      immediate: true,
      handler(language) {
        this.$bind(
          "sideMenu",
          sideMenusCollection.doc(language + appMapSuffix)
        );
      }
    },
    dialog(val) {
      val || this.close();
    }
  }
};
</script>

<style lang="sass" module>
.listAction
  flex-direction: row
</style>
